export enum CardExpirationStatusEnum {
  Expired = 'Expired',
  ExpiringSoon = 'ExpiringSoon',
  Unknown = 'UNKNOWN',
}
